// extracted by mini-css-extract-plugin
export default {"noShrink":"kVdXA","thumbnail":"ADmEN","thumbnailWrapper":"j1bvm"};